<template>
    <div class="labelled-text" :class="[{ row: row }, { tiny: tiny }]">
        <div class="labelled-text-title">
            <slot name="title"></slot>
        </div>
        <div class="labelled-text-subtitle">
            <slot name="subtitle"></slot>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "LabelledText",
    props: {
        row: {
            type: Boolean,
            default: false,
        },
        tiny: {
            type: Boolean,
            default: false,
        },
    },
});
</script>

<style lang="scss" scoped>
@import "@/styles/colors.scss";
@import "@/styles/mixins.scss";

.labelled-text {
    display: flex;
    flex-direction: column;

    &-title {
        flex: 1;
        font-size: 1rem;
        font-weight: bold;
        margin-right: 0.25rem;
        color: $slks-light-gray;
        @include print-black();
    }

    &-subtitle {
        // flex: 1;
        font-size: 1rem;
        font-weight: 300;
        // display: flex;
        justify-content: flex-start;
        align-items: baseline;
        flex-direction: row;
        width: 65%;
        @include print-black();
    }

    &.tiny {
        .labelled-text-title {
            font-size: 0.8125rem;
        }

        .labelled-text-subtitle {
            font-size: 0.8125rem;
        }
    }

    @include desktop {
        flex-direction: row;

        &:not(.tiny) {
            .labelled-text-subtitle {
                flex: 2;
                overflow: hidden;
            }
        }
    }

    &.row {
        flex-direction: row;

        @include mobile {
            flex-direction: column;
        }
    }
}

@media (max-width: 1024px) {
    .labelled-text {
        flex-direction: row;

        &-subtitle {
            font-size: 10px;
        }

        &-title {
            flex: none;
            font-size: 10px !important;
            font-weight: bold;
            margin-right: 0.25rem;
            color: $slks-light-gray;
            width: 35%;
            @include print-black();
        }

        &.tiny {
            .labelled-text-title {
                font-size: 10px;
            }

            .labelled-text-subtitle {
                font-size: 10px;
            }
        }
    }
}
</style>
